import { Loader2 } from 'lucide-react';

export default function LoadingSpinner({ message = 'Loading...' }) {
  return (
    <div className="flex flex-col items-center justify-center py-12">
      <Loader2 size={32} className="animate-spin text-purple-600 mb-4" />
      <p className="text-gray-500 text-sm">{message}</p>
    </div>
  );
}
